import IntegrationsUploads from 'enrollment-platform/pages/CensusManagement/pages/IntegrationsUploads'
import CencusApiActivity from './pages/CencusApiActivity'
import PayrollApiActivity from './pages/PayrollApiActivity'

export const ApiVisibilityChildRoutes = [
  {
    path: 'census-api-activity',
    component: CencusApiActivity,
  },
  {
    path: 'payroll-api-activity',
    component: PayrollApiActivity,
  },
  {
    path: 'cmv2-api-visibility',
    component: IntegrationsUploads,
  },
]

export default ApiVisibilityChildRoutes
